import React from 'react';
import {Sidebar} from '../components/Sidebar';
import {ids} from '../utils/constants';
import {useExpiresToken} from '../hooks/useExpiresToken';
import styles from './layouts.module.scss';
import {LayoutTop} from './LayoutTop';
import {ILayoutsProps} from './types';
import {Footer} from './Footer';

export const MainLayout = ({children}: ILayoutsProps) => {
    useExpiresToken();
    return (
        <div className={styles.wrapper}>
            <LayoutTop/>
            <div className={styles.content}>
                <div className={styles.content__box}>
                    <Sidebar/>
                </div>
                <div className={styles.content__box} id={ids.layoutRightBox}>
                    {children}
                </div>
            </div>
            <Footer/>
        </div>
    );
};
